import { useNavigate } from 'react-router-dom';
import styles from '../styles/404.module.css';
import { useEffect } from 'react';

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = '404 - Page Not Found';
    // Masquer le contenu principal de l'application
    const appRoot = document.getElementById('root');
    if (appRoot) {
      appRoot.style.background = '#0a0a0a';
    }
    
    return () => {
      // Restaurer le style original
      if (appRoot) {
        appRoot.style.background = '';
      }
    };
  }, []);

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorContent}>
        <div className={styles.number}>4</div>
        <div className={styles.circle}></div>
        <div className={styles.number}>4</div>
        <p className={styles.text}>Oops! Page not found</p>
        <p className={styles.subtext}>The page you are looking for does not exist or is invalid.</p>
        <button 
          onClick={() => navigate('/')} 
          className={styles.button}
        >
          RETURN TO HOMEPAGE
        </button>
      </div>
    </div>
  );
} 